import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../utils/api';
import { toast } from 'react-toastify';


export const addAccountUserThunk = createAsyncThunk(
    'customer/addBilling',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.addAccountUser(data);
            dispatch(setAccountUserRefresh())
            toast.success('Account user added successfully')
            return response.status;
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message || 'something went wrong')
        }
    }
);


export const updateUserAccountThunk = createAsyncThunk(
    'customer/updateUserAccountThunk',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.updateAccountUser(data);
            dispatch(setAccountUserRefresh())
            toast.success('Account user updated successfully')
            return response.status;
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message || 'something went wrong')

        }
    }
);

export const getAllAccountUserThunk = createAsyncThunk(
    'customer/getAllAccountUser',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.getAllAccountUsers(data);
            return response.data?.data;
        } catch (error) {
            console.log(error);

        }
    }
);


export const getAccountUserDetailsThunk = createAsyncThunk(
    'customer/getAccountUserDetails',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.getAccountuserDetails(data);
            return response.data?.data;
        } catch (error) {
            console.log(error);

        }
    }
);

export const deleteUserAccountThunk = createAsyncThunk(
    'customer/deleteUserAccountThunk',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.deleteAccountUser(data);
            dispatch(setAccountUserRefresh())
            toast.success('Account user deleted successfully')
            return response.status;
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message || 'something went wrong')

        }
    }
);


export const changeAccountUserPassword = createAsyncThunk(
    'customer/changeAccountUserPassword',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.changeAccountuserPassword(data);
            dispatch(setAccountUserRefresh())
            toast.success('Password changed successfully')
            return response.status;
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message || 'something went wrong')

        }
    }
);

const initialState = {
    loading: false,
    refresh: false,
    users:[],
    userDetails:{},
    page:1
};

const accountUser = createSlice({
    name: 'accountUser',
    initialState,
    reducers: {

        setAccountUserRefresh: (state, action) => {
            state.refresh = !state.refresh
        },
        setAccountUserPage :(state,action)=>{
            state.page = action.payload
        }

    },
    extraReducers: (builder) => {
        builder

            .addCase(addAccountUserThunk.pending, (state) => {
                state.loading = true;
            })
            .addCase(addAccountUserThunk.fulfilled, (state, action) => {
                state.loading = false;

            })
            .addCase(addAccountUserThunk.rejected, (state, action) => {
                state.loading = false;
            })

            //upadte
            .addCase(updateUserAccountThunk.pending, (state) => {
                state.loading = true;
            })
            .addCase(updateUserAccountThunk.fulfilled, (state, action) => {
                state.loading = false;

            })
            .addCase(updateUserAccountThunk.rejected, (state, action) => {
                state.loading = false;
            })

            //getAlluser
            .addCase(getAllAccountUserThunk.pending, (state) => {
                state.loading = true;
            })
            .addCase(getAllAccountUserThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.users = action.payload
            })
            .addCase(getAllAccountUserThunk.rejected, (state, action) => {
                state.loading = false;
            })

             //getUserDetails
             .addCase(getAccountUserDetailsThunk.pending, (state) => {
                state.loading = true;
            })
            .addCase(getAccountUserDetailsThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.userDetails = action.payload
            })
            .addCase(getAccountUserDetailsThunk.rejected, (state, action) => {
                state.loading = false;
            })

             //changeAccountUserPassword
             .addCase(changeAccountUserPassword.pending, (state) => {
                state.loading = true;
            })
            .addCase(changeAccountUserPassword.fulfilled, (state, action) => {
                state.loading = false;
           
            })
            .addCase(changeAccountUserPassword.rejected, (state, action) => {
                state.loading = false;
            })

    },
});

export const { setAccountUserRefresh,setAccountUserPage } = accountUser.actions
export default accountUser.reducer